import React from 'react';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const DrawerWrapper = ({ anchor, open, toggleDrawer, drawerContent }) => {
  const theme = useTheme();

  return (
    <MuiDrawer
      anchor={anchor}
      open={open}
      onClose={toggleDrawer}
      sx={{
        [`& .${drawerClasses.paper}`]: {
          backgroundColor: theme.palette.drawer.main,
          color: theme.palette.drawer.contrastText,
          width: 320,
          padding: '8px',
          borderRadius: anchor === 'left' ? '0 8px 8px 0' : '8px 0 0 8px',
        },
      }}
    >
      <Box sx={{ mt: 0 }}>{drawerContent}</Box>
    </MuiDrawer>
  );
};

export default DrawerWrapper;
